export default __webpack_public_path__ + "static/media/fastclix_lancets@2x.5cf38164.webp";